import { LoginFlow, SetLoginFlow } from "./LoginScreen.types";
export const getIsSimplifiedLogin = _ref => {
  let {
    setLoginFlow,
    locationSearch,
    hasVendorAccount
  } = _ref;
  const clientView = new URLSearchParams(locationSearch).get('view') === 'client';
  if (setLoginFlow != null) return setLoginFlow === SetLoginFlow.OtpLogin;

  // in case we didnt come from notification or no-access page and we have a cookie
  if (hasVendorAccount != null) return !hasVendorAccount;
  return clientView;
};
export function getTheNextStep(_ref2) {
  let {
    flow,
    isSimplifiedLogin
  } = _ref2;
  if (isSimplifiedLogin) {
    return LoginFlow.OTP;
  }
  if (flow === LoginFlow.EmailVerification) {
    return LoginFlow.EmailVerification;
  }
  return flow;
}